import request from './request'

export function listMoTool(moId) {
  return request.get('/mes/mo-tools/' + moId)
}

export function saveMoTool(data) {
  return request.post('/mes/mo-tools/save', data)
}
